module.exports = __webpack_public_path__ + "img/ga-web-dev-intro.8820daef.jpg";